import { TextSelection } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';

/**
 * The editor takes the page's selection as it is now. The editor reads a selection change
 * a moment after the page makes it, and now and then misses one made with the keyboard
 * (Home, then Shift+End), so a toolbar button or a key straight after would act on the
 * selection before it - a font put on nothing, the Thesaurus opened on another word.
 * Anything that acts on the selection calls this first.
 */
export function syncSelection(view: EditorView): void {
  const sel = view.dom.ownerDocument.getSelection();
  if (!sel || !sel.anchorNode || !sel.focusNode || !view.dom.contains(sel.anchorNode) || !view.dom.contains(sel.focusNode)) return;
  try {
    const anchor = view.posAtDOM(sel.anchorNode, sel.anchorOffset);
    const head = view.posAtDOM(sel.focusNode, sel.focusOffset);
    const { selection } = view.state;
    if (selection.anchor !== anchor || selection.head !== head) view.dispatch(view.state.tr.setSelection(TextSelection.create(view.state.doc, anchor, head)));
  } catch {
    // A position the document doesn't have: keep the editor's own.
  }
}
